module.exports = __webpack_public_path__ + "static/media/SarahSwitek_10_Questions_7.892bb577.mp3";